import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "../../client/client";
import Barcode from "react-barcode";
import { useUsers } from "../../context/UserContext";
import { useLogin } from "../../context/LoginContext";
import Loading from "../Loading";
import Layout from "../Layout";
import FetchSoftwareDetail from "./FetchSoftwareDetail";
import FetchMaintenanceDetail from "./FetchMaintenanceDetail";

const ProductDetailPage = () => {
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState(null);
  const [images, setImages] = useState([]);
  const { slug } = useParams();
  const { getUser } = useUsers();
  const { getSessionAuth } = useLogin();
  const navigate = useNavigate();

  useEffect(() => {
    const sessionAuth = async () => {
      const session = await getSessionAuth();
      if (session) {
        await getUser(session.id);
      } else {
        navigate("/", { replace: true });
      }
    };
    sessionAuth();
  }, []);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const { data, error } = await supabase
          .from("equipos")
          .select("*")
          .eq("id", slug)
          .single();

        if (error) {
          console.error("Error fetching product:", error);
        }
        setProduct(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching product:", error.message);
      }
    };

    fetchProduct();
  }, [slug]);

  if (!product) {
    return <div>Loading...</div>;
  }

  return (
    <Layout>
      {loading && <Loading />}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        <div className="w-full p-5">
          {/* {Array.isArray(product.images) && product.images.length > 0 ? ( */}
          {/* <ProductSlideshow images={product.image1} /> */}
          {/* ) : (
           
          {/* )} */}
          <img
            src={product.image1}
            alt={product.title}
            className="w-full aspect-square"
          />
        </div>
        <div className="w-full">
          <h2 className="text-3xl font-bold">{product.title}</h2>
          <h3 className="text-lg font-medium">{product.area}</h3>
          <h4 className="text-sm font-medium">
            <strong>Encargado/a:</strong> {product.attendant}
          </h4>
          <h2 className="text-3xl font-bold text-[#4691A6] flex justify-center mt-10">HARDWARE</h2>
          <div className="grid grid-cols-2 mt-5 ">
            <div className="flex flex-col p-4 border-2 border-black border-r-0 border-b-0">
              <h5 className="text-sm font-bold">Tipo de activo:</h5>
              <p className="text-sm font-medium">{product.active_type}</p>
            </div>
            <div className="flex flex-col p-4 border-2 border-black border-b-0">
              <h5 className="text-sm font-bold">Modelo:</h5>
              <p className="text-sm font-medium">{product.model}</p>
            </div>
            <div className="flex flex-col p-4 border-2 border-black border-r-0 border-b-0">
              <h5 className="text-sm font-bold">Marca:</h5>
              <p className="text-sm font-medium">{product.brand}</p>
            </div>
            <div className="flex flex-col p-4 border-2 border-black border-b-0">
              <h5 className="text-sm font-bold">Número de serie:</h5>
              <p className="text-sm font-medium">{product.serial}</p>
            </div>
            <div className="flex flex-col p-4 border-2 border-black border-r-0 border-b-0">
              <h5 className="text-sm font-bold">Color:</h5>
              <p className="text-sm font-medium">{product.color}</p>
            </div>
            <div className="flex flex-col p-4 border-2 border-black border-b-0">
              <h5 className="text-sm font-bold">Estado:</h5>
              <p className="text-sm font-medium">{product.state}</p>
            </div>
            <div className="flex flex-col p-4 border-2 border-black border-r-0 border-b-0">
              <h5 className="text-sm font-bold">Medidas:</h5>
              <p className="text-sm font-medium">{product.measures}</p>
            </div>
            <div className="flex flex-col p-4 border-2 border-black border-b-0">
              <h5 className="text-sm font-bold">Constancia de uso:</h5>
              <p className="text-sm font-medium">{product.condition_use}</p>
            </div>
            <div className="flex flex-col p-4 border-2 border-black border-r-0">
              <h5 className="text-sm font-bold">Cantidad:</h5>
              <p className="text-sm font-medium">{product.quantity}</p>
            </div>
            <div className="flex flex-col p-4 border-2 border-black">
              <h5 className="text-sm font-bold">Fecha de despacho:</h5>
              <p className="text-sm font-medium">
                {product.shipping_date
                  ? new Date(product.shipping_date + "T00:00:00")
                      .toLocaleDateString("es-ES", { year: "numeric", month: "long", day: "numeric" })
                      .replace(/^\w/, (c) => c.toUpperCase())
                  : "Sin fecha"}
              </p>
            </div>
          </div>
          <div className="w-full mt-5">
            <Barcode
              value={product.id}
              width={1.35}
              height={80}
              background="#7dcbe1"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        <div>
          <h2 className="text-3xl font-bold text-[#4691A6] flex justify-center mt-10">MANTENIMIENTO</h2>
          <div className=" mt-5 ">
            <div className="flex flex-col p-4 border-2 border-black">
            <h3 className="font-bold text-[#4691A6] flex justify-center m-2">ÚLTIMO MANTENIMIENTO REALIZADO</h3>
              <FetchMaintenanceDetail />
            </div>

          </div>
        </div>

        <div>
          <h2 className="text-3xl font-bold text-[#4691A6] flex justify-center mt-10">SOFTWARE</h2>
          <div className=" mt-5 ">
            <div className="flex flex-col p-4 border-2 border-black">
              <h3 className="font-bold text-[#4691A6] flex justify-center m-2">LICENCIAS</h3>
              <FetchSoftwareDetail />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ProductDetailPage;
